class Browser {
    static handleTabTitle(p = {}) {
        const { tenant } = p;

        if (tenant?.name) {
            document.title = `Auvik SaaS Management | ${tenant.name}`;
            return;
        }

        document.title = 'Auvik SaaS Management';
    }
}

export default Browser;
